exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.small {\n  height: calc(100% - 50px);\n  max-width: 850px;\n  width: calc(100% - 80px);\n  margin:  80px auto;\n  background-color: whitesmoke !important;\n}\n", ""]);

// exports
